import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SCDService } from '@shared/services/scd.service';
import { ISCDUserDto } from '@shared/interfaces/user/ISCDUser';

@Component({
    selector: 'app-scd-extern-dialog',
    templateUrl: './scd-extern-dialog.component.html',
    styleUrls: ['./scd-extern-dialog.component.scss'],
    standalone: false
})
export class ScdExternDialogComponent {
    protected displayedColumns = ['selected', 'firstName', 'surName', 'eMail', 'department'];
    protected dataSource: ISCDUserDto[] = [];
    protected firstName = '';
    protected surName = '';
    protected eMail = '';
    protected selectedUser: ISCDUserDto;

    private options: { users: ISCDUserDto };

    constructor(
        public dialogRef: MatDialogRef<ScdExternDialogComponent>,
        private scdService: SCDService,
        @Inject(MAT_DIALOG_DATA) public data: { users: ISCDUserDto }
    ) {
        this.options = data;
        if (this.options.users) {
            this.selectedUser = this.options.users;
        }
    }

    protected async applyFilter(event: KeyboardEvent | PointerEvent): Promise<void> {
        if ((event as KeyboardEvent).code !== 'Enter' && event.type !== 'click') {
            return;
        }

        const result = await this.scdService.searchUserInSCD(this.firstName, this.surName, this.eMail);
        this.dataSource = result.records;
    }

    protected clearFilter(): void {
        this.firstName = '';
        this.surName = '';
        this.eMail = '';
        this.selectedUser = null;
        this.dataSource = [];
    }

    protected changeSelected(selectedUser: ISCDUserDto): void {
        this.selectedUser = selectedUser;
    }

    protected closeDialog(): void {
        this.dialogRef.close(this.selectedUser);
    }
}
